const PrintAttendee = ({ stylingForm, CSSValues, specialCSSRules, fieldOrdering }) => {
    // If present, parsed template stylingForm as backup
    const mainStylingForm = stylingForm?.mainTemplate?.stylingForm
        ? JSON.parse(stylingForm.mainTemplate.stylingForm)
        : {};

    // Proper normalization for field key (camelCase/first char lower)
    const toLowerCamelCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    // Try to get value from live form, then from template
    const getFieldValue = (cssFieldName) => {
        // Try live form (e.g. stylingForm.firstName)
        const camel = toLowerCamelCase(cssFieldName);
        if (stylingForm && (stylingForm[cssFieldName] !== undefined)) return stylingForm[cssFieldName];
        if (stylingForm && (stylingForm[camel] !== undefined)) return stylingForm[camel];
        if (mainStylingForm && (mainStylingForm[cssFieldName] !== undefined)) return mainStylingForm[cssFieldName];
        if (mainStylingForm && (mainStylingForm[camel] !== undefined)) return mainStylingForm[camel];
        return "";
    };

    const determineTextStyle = (cssFieldName, fieldValue) => {
        const defaultStyle = { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0" };
        const specialCssSmaller = specialCSSRules?.[`${cssFieldName}Smaller`];
        const specialCssSmallest = specialCSSRules?.[`${cssFieldName}Smallest`];

        if (!fieldValue) return defaultStyle;
        if (specialCssSmallest?.active && fieldValue.length > specialCssSmallest.length) return CSSValues[`${cssFieldName}Smallest`] || defaultStyle;
        if (specialCssSmaller?.active && fieldValue.length > specialCssSmaller.length) return CSSValues[`${cssFieldName}Smaller`] || defaultStyle;
        return CSSValues[cssFieldName] || defaultStyle;
    };

    const renderTextField = (cssFieldName) => {
        const fieldValue = getFieldValue(cssFieldName);

        if (!CSSValues[cssFieldName] && cssFieldName !== "ScannerField") return null;

        const style = determineTextStyle(cssFieldName, fieldValue);
        return <p key={cssFieldName} style={style}>{fieldValue}</p>;
    };

    const renderImageField = (cssFieldName) => {
        const imageCSS = CSSValues[cssFieldName] || {
            width: "20px",
            height: "20px",
            marginTop: "10px",
            padding: "0",
            position: "relative",
            left: "150px"
        };
        const imageFile = getFieldValue(cssFieldName);

        return imageFile ? <img key={cssFieldName} style={imageCSS} src={imageFile} alt={cssFieldName} /> : null;
    };

    return (
        <>
            {fieldOrdering.map((field) => {
                if (/scannerfield|image/i.test(field.cssFieldName)) {
                    return renderImageField(field.cssFieldName);
                }
                return renderTextField(field.cssFieldName);
            })}
        </>
    );
};

export default PrintAttendee;